import { render, staticRenderFns } from "./payin.vue?vue&type=template&id=bcb4897a&scoped=true"
import script from "./payin.vue?vue&type=script&lang=js"
export * from "./payin.vue?vue&type=script&lang=js"
import style0 from "./payin.vue?vue&type=style&index=0&id=bcb4897a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb4897a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bcb4897a')) {
      api.createRecord('bcb4897a', component.options)
    } else {
      api.reload('bcb4897a', component.options)
    }
    module.hot.accept("./payin.vue?vue&type=template&id=bcb4897a&scoped=true", function () {
      api.rerender('bcb4897a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/data-agent/payin.vue"
export default component.exports